import { Injectable } from "@angular/core";
import { DataService } from "@app/core";
import { FileMimeType, SaveFileResult } from "@app/shared/file-uploader";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class FileUploaderService {
  private serviceUrl = "FileUploader";
  constructor(private http: DataService) {}

  saveFile(file: File, storageFolder: string): Observable<string> {
    return this.http.uploadFile(`${this.serviceUrl}/${storageFolder}`, file).pipe(map((response: SaveFileResult) => response?.link || ""));
  }

  uploadFormData(formData: FormData, storageFolder: string): Observable<string> {
    return this.http.uploadFormData(`${this.serviceUrl}/${storageFolder}`, formData).pipe(map((response) => response.link));
  }

  getAcceptedFiles(extensions: Array<FileMimeType>) {
    return `${extensions?.length ? extensions?.join(", ") : "application/*"}`;
  }
}
